module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d02e782a95bdc8bfb7157ad4b92acceb.png";